/**
 * This module contains utility functions for manipulating date going into or coming out of
 * Canvas components.
 */

export const fromDateToUiDateInputFormat = date => ({
  year: date.getUTCFullYear(),
  month: date.getUTCMonth(),
  date: date.getUTCDate()
});
export const fromUiDateInputFormatToUnixTs = date => {
  const dateObj = new Date(Date.UTC(date.year, date.month, date.date, 23, 59, 59, 999));
  return dateObj.getTime();
};